/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Park',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            fillRule="evenodd"
            d="M8.682 2.38c1.283.135 2.251 1.257 2.251 2.576l-.003.075c1.115.441 1.891 1.553 1.892 2.837 0 .547-.142 1.062-.389 1.506.402.531.643 1.198.644 1.922l-.004.159c-.022.453-.142.882-.333 1.267h8.117a.6.6 0 0 1 .601.6v2.859a.6.6 0 0 1-.601.6h-1.652v1.124h1.677l.121.013a.6.6 0 0 1 .467.467l.013.121a.6.6 0 0 1-.601.6h-1.677v1.329h2.24a.6.6 0 0 1 .601.6.6.6 0 0 1-.601.6H2.555a.6.6 0 0 1-.6-.6.6.6 0 0 1 .6-.6h3.74v-5.012c-1.148-.291-2.045-1.206-2.357-2.36a3.05 3.05 0 0 1-1.47-2.404l-.008-.23a3.09 3.09 0 0 1 .595-1.826c-.219-.469-.344-.994-.344-1.549 0-1.952 1.526-3.576 3.459-3.576l.16.004.026.001c.449-.668 1.2-1.116 2.064-1.116l.261.014zm5.82 16.726v1.329h3.502v-1.329h-3.502zm-3.452-4.856c-.266.096-.55.156-.846.172l-.158.004c-.172 0-.34-.018-.503-.047v6.057h3.759v-1.329h-1.678a.6.6 0 0 1-.12-1.187l.12-.013h1.678v-1.124h-1.652a.6.6 0 0 1-.6-.6v-1.932zm-2.706-1.228a2.47 2.47 0 0 1-.85.162v7.25h.85v-7.412zm6.158 4.884h3.502v-1.124h-3.502v1.124zm-2.253-2.324h8.008v-1.66h-8.008v1.66zM8.421 3.565c-.514 0-.974.317-1.188.803a.6.6 0 0 1-.66.348c-.132-.025-.267-.039-.402-.039-1.226 0-2.26 1.042-2.26 2.377l.007.18c.03.414.161.797.366 1.124a.6.6 0 0 1-.083.741c-.331.334-.541.804-.541 1.33 0 .717.389 1.328.94 1.632l.112.057.064.035a.6.6 0 0 1 .276.405c.132.738.613 1.328 1.242 1.601v-1.286a.6.6 0 0 1-.184-.758.6.6 0 0 1 .807-.261c.025.013.051.023.077.034a.59.59 0 0 1 .173.059c.556.141 1.188-.122 1.49-.712a.6.6 0 1 1 1.069.546 2.62 2.62 0 0 1-.185.302v1.066a1.73 1.73 0 0 0 .503.078c.988 0 1.831-.842 1.831-1.93a1.97 1.97 0 0 0-.61-1.434.6.6 0 0 1-.057-.811c.223-.28.371-.63.404-1.016l.008-.168c0-.929-.648-1.672-1.458-1.814a.6.6 0 0 1-.479-.738 1.47 1.47 0 0 0 .048-.359l-.008-.146c-.069-.717-.646-1.245-1.305-1.245z"
            fill="currentColor"
          />
        </>
      )
    }
  }
};

const icon = createSvgIcon(config);
export default icon;
